import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';

import './ImageSliderAppearance.css';


class ImageSliderAppearance extends Component {
  static propTypes = {
    patchImageSlider: PropTypes.func.isRequired,
    item: PropTypes.object,
  };

  static defaultProps = {
    item: null,
  };

  state = {
    currentTitleDescriptionColor: null,
    currentLinkTextColor: null,
    currentButtonBackgroundColor: null,
    currentNavigationColor: null,
  };

  componentDidMount() {
    this.setState({
      currentTitleDescriptionColor: this.props.item.title_description_color,
      currentLinkTextColor: this.props.item.text_color,
      currentButtonBackgroundColor: this.props.item.button_bg_color,
      currentNavigationColor: this.props.item.nav_color,
    });
  }

  onChangeColor = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    this.props.patchImageSlider(this.props.item.id, form);
  };

  onTitleDescriptionColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onChangeColor('title_description_color', rgba);
    this.setState({ currentTitleDescriptionColor: rgba });
  };

  onLinkTextColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onChangeColor('text_color', rgba);
    this.setState({ currentLinkTextColor: rgba });
  };

  onButtonBackgroundColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onChangeColor('button_bg_color', rgba);
    this.setState({ currentButtonBackgroundColor: rgba });
  };

  onNavigationColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onChangeColor('nav_color', rgba);
    this.setState({ currentNavigationColor: rgba });
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="image-slider-appearance__component">
            {/* Title & Description Color */}
            <div className="section">
              <div className="title">{t("Title & Description Color")}</div>
              <ColorPicker
                small
                key="title-description-color-picker-key"
                pickerId="title-description-color-picker-id"
                color={this.state.currentTitleDescriptionColor || '#bebebe'}
                onChangeComplete={this.onTitleDescriptionColorChange}
              />
            </div>

            {/* Link Text Color */}
            <div className="section">
              <div className="title">{t("Link Text Color")}</div>
              <ColorPicker
                small
                key="link-text-color-picker-key"
                pickerId="link-text-color-picker-id"
                color={this.state.currentLinkTextColor || '#bebebe'}
                onChangeComplete={this.onLinkTextColorChange}
              />
            </div>

            {/* Button Background Color */}
            <div className="section">
              <div className="title">{t("Button Background Color")}</div>
              <ColorPicker
                small
                key="button-background-color-picker-key"
                pickerId="button-background-color-picker-id"
                color={this.state.currentButtonBackgroundColor || '#bebebe'}
                onChangeComplete={this.onButtonBackgroundColorChange}
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default connect(
  null,
  {
    patchImageSlider,
  },
)(ImageSliderAppearance);
